import React from 'react';
import theme from './theme';
import Container from './Container';
import AppLayout from '../../front/Layout/AppLayout';
import { ThemeProvider } from '@material-ui/core/styles';
import AuthDialogContextProvider from '../../front/components/AuthDialog/AuthDialogContextProvider';

const Jtb = ({
  plans = [],
  businesses = [],
  authenticated,
  ...headerProps
}) => {
  return (
    <AuthDialogContextProvider>
      <AppLayout {...headerProps} authenticated={authenticated}>
        <ThemeProvider theme={theme}>
          <Container
            plans={plans}
            businesses={businesses}
            isAuthenticated={authenticated}
          />
        </ThemeProvider>
      </AppLayout>
    </AuthDialogContextProvider>
  );
};

export default Jtb;
